// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDZq0lyb7-AbD7BvZ1yBxj9To5thvp7oTA",
  authDomain: "theatre-b48ab.firebaseapp.com",
  projectId: "theatre-b48ab",
  storageBucket: "theatre-b48ab.appspot.com",
  messagingSenderId: "800402133808",
  appId: "1:800402133808:web:577b04a7bd1148a0256ef5",
  measurementId: "G-2X07LVB8HZ"
};


const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.log('Analytics initialization skipped:', error.message);
  }
}
export { analytics };